import { z } from 'zod';

const cardApplicationObjectSchema = z.object({
  labelText: z.string(),
  name: z.string(),
  checked: z.literal(true),
});

const cardApplicationObjectSchemaOptional = z.object({
  labelText: z.string(),
  name: z.string(),
  isChecked: z.literal(true).optional(),
});

export const cardApplicationSchema = z.tuple([
  cardApplicationObjectSchema,
  cardApplicationObjectSchema,
  cardApplicationObjectSchema,
  cardApplicationObjectSchemaOptional,
]);

export const cardApplicationAllCheckedSchema = z.array(
  cardApplicationObjectSchema,
);
